export default "__VITE_ASSET__8e99853c__"